// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_r1-5";
export var filledCircle = "_r1-4";
export var historyEntry = "_r1-3";
export var messageSideLeft = "_r1-1";
export var messageSideRight = "_r1-2";
export var orderTrackingCarouselWrapper = "_r1-6";
export var orderTrackingInfoContainer = "_r1-0";